/**
 * Common Styled Components (Not Theme-Specific)
 */

import { css } from "styled-components";

// Visually hidden in place.
// Not placed off page to prevent page scrolls for focusable elements, e.g. inputs.
export const VisuallyHide = css`
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0 0 0 0);
  clip-path: inset(50%); // Ignored by IE11
  border: 0;
`;
